define('page-list-navigation',['jquery'],
function ($) {
    var pageListContentClass = '.page-list__content';

	function hashDealer(){
		
		var hash = window.location.hash;

	    if (hash == "") {
	        return;
	    }

	    hash = hash.substring(1, hash.length);
	    var $foundElement = $('[data-anchor="' + hash + '"]').first();

	    if ($foundElement.length != 0) {
	        $foundElement.find('[data-page-list-toggler]').trigger('dope');
	    }
	}

	setTimeout(hashDealer, 500);
	$(window).on('hashchange', hashDealer);


	$('[data-page-list-toggler]').each(function (index) {
		var elm = $(this).next(pageListContentClass);
		var elmHeight = elm.outerHeight(true);
		elm.data('outerheight', elmHeight);

        elm.css({ 'height': '0', 'visibility': 'visible' });
	});
	

	if ($('body').data('ispageedit') == true) {
		$('[data-page-list-toggler]').parents('.grid-3').next().css({ 'height': 'auto', 'visibility': 'visible' });
	}

	//Click on opened. Close it
	$('[data-page-list-toggler]').on('click', function(e){
		var $this = $(this);
		
		if(window.location.hash && $this.attr('href') === window.location.hash){


			if ($this.hasClass('active')){

				window.location.hash = 'closed';

				$dataContainer = $(this).next(pageListContentClass);
				$thisContainer = $this.parents('li');

				$dataContainer.removeClass('expanded').animate({height: 0}, (500));
				$this.removeClass('active');
				$thisContainer.removeClass('active');

				return false;

			}
		}
	});

	$('[data-page-list-toggler]').on('dope', function(e){

		var $this = $(this),
			$dataContainer = $this.next(pageListContentClass);
			$thisContainer = $this.parents('li');
			$thisContent = $this.parent();
			$thisContentHeight = $thisContent.outerHeight(true);
			$thisHash = $this.attr('href');


        var thisHeight = $dataContainer.data('outerheight');

		
		if ($this.hasClass('active')){
			$dataContainer.removeClass('expanded').animate({height: 0}, (500));
			$this.removeClass('active');
			$thisContainer.removeClass('active');
		}
		else{
			if ($thisContainer.siblings().find('.active').length != 0){
				$dataContainer.parent().siblings().children('.expanded').removeClass('expanded').animate({
					height: 0
				}, (500), function() {
					$thisContainer.siblings().find('.active').removeClass('active').parents('li').removeClass('active');
					$dataContainer.addClass('expanded').css({ 'display': 'block'}).animate({
						height: thisHeight
					}, (500));
					$this.addClass('active');
					$thisContainer.addClass('active');
				});
			}
			else{
				$dataContainer.addClass('expanded').css({ 'display': 'block'}).animate({
					height: thisHeight
				}, (500));
				$this.addClass('active');
				$thisContainer.addClass('active');
			}
		}
		setTimeout(function(){$('html, body').animate({ scrollTop: $this.next(pageListContentClass).offset().top - $thisContentHeight }, 500);}, 500);
	});
});

